import { darken, lighten } from '@mui/material';
import {
  BRAND_COLOR_RED,
  BRAND_COLOR_ORANGE,
  BRAND_COLOR_YELLOW,
} from '../../constants';
import { Project } from '../../types';

export const PROJECT_SAMUELGOODELL_CALENDLY_PROXY_API: Project = {
  id: '@samuelgoodell/calendly-proxy-api',
  name: 'Calendly Proxy API',
  description:
    'Proxy for the Calendly API which securely uses my personal access token',
  status: 'maintenance',
  chip: {
    background: `linear-gradient(135deg, ${BRAND_COLOR_RED} 0%, ${lighten(
      BRAND_COLOR_ORANGE,
      0.15
    )} 100%)`,
    color: 'rgb(255, 255, 255)',
    content: '@samuelgoodell/calendly-proxy-api',
  },
  page: {
    tabs: [
      {
        label: 'Overview',
        page: {
          markdown: `\
_TODO_
`,
        },
      },
    ],
  },
};
